import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeTypesParams } from './service';

export enum HomeTypesActions {
  Failure = '[Catalogs HomeTypes] Failure',
  Request = '[Catalogs HomeTypes] Request',
  Success = '[Catalogs HomeTypes] Success',
}

export const HomeTypesFailure = createAction(HomeTypesActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeTypesRequest = createAction(HomeTypesActions.Request, props<{ parameters?: HomeTypesParams }>());

export const HomeTypesSuccess = createAction(HomeTypesActions.Success, props<{ data: ParameterResult[] }>());
